import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { KpiPage } from './kpi.page';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./categories/categories.module').then( m => m.CategoriesPageModule)
  },/* 
  {
    path: ":id",
    loadChildren: () =>
      import("../kpi-detail/kpi-detail.module").then(
        (m) => m.KpiDetailPageModule
      ),
  }, */
  {
    path: 'categories',
    loadChildren: () => import('./categories/categories.module').then( m => m.CategoriesPageModule)
  },
  {
    path: 'categories/:idCategory/indicators',
    loadChildren: () => import('./indicators/indicators.module').then( m => m.IndicatorsPageModule)
  },
  
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class KpiPageRoutingModule {}
